export const videoTypes = ['instream', 'outstream'] as const

export type VideoType = (typeof videoTypes)[number]
